import type { ConsumptionYearlyData, ConsumptionZone } from 'types'

import styled from 'styled-components'

import copy from 'copy.json'
import Badge from 'pages/matches/Badge'

const texts = copy.components.consumption_details.year_summary

type Props = {
  data: ConsumptionYearlyData | null
}

export default function YearSummary({ data }: Props) {
  if (!data) return null

  const zones: ConsumptionZone[] = Object.values(data.zone_data)

  return (
    <Wrapper>
      <h4>{texts.title}</h4>

      <Total>
        <p>{texts.total_consumption}</p>
        <Badge>
          {data.total.toFixed(0)} {copy.common.MWh}
        </Badge>
      </Total>

      <Row>
        {zones.map((zone, index) => (
          <Column key={index}>
            <div>
              <Badge secondary border>
                {texts.zone} {index + 1}
              </Badge>

              <span className="zoneDescription">{texts.consumption[zones.length - 1][index]}</span>
            </div>

            <Badge
              morningConsumption={index === 0}
              afternoonConsumption={index === 1}
              restConsumption={index === 2}
            >
              {zone.consumption.toFixed(0)} {copy.common.MWh}
            </Badge>

            <Badge>{zone.participating_percentage.toFixed(0)}%</Badge>
          </Column>
        ))}
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 16px;

  width: 100%;
  padding: 24px max(24px, calc((100% - 646px) / 2));

  background: var(--very-light-green);
  border: 1px solid var(--green);
  border-radius: 4px;

  h4 {
    font: var(--600-16);
  }

  p {
    font: var(--600-13);
  }
`

const Total = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  ${Badge} {
    font: var(--600-24);
  }
`

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;

  > div {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .zoneDescription {
    color: var(--gray);
    font: var(--600-12);
    max-width: 100px;
  }
`
